// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";
import GradientHeader from "src/components/shared/displays/GradientHeader/GradientHeader";
import General from "./General/General";
import VisualField from "./VisualField/VisualField";
import VisualAcuity from "./VisualAcuity/VisualAcuity";
import ContrastSensitivity from "./ContrastSensitivity/ContrastSensitivity";
import ColorVision from "./ColorVision/ColorVision";

type FeaturesType = {
  title: string;
};

const Features = ({ title }: FeaturesType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Box
        id="general"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`3.1 ${t("General")}`} />
        <Box sx={{ mx: "20px" }}>
          <General />
        </Box>
      </Box>

      <Box
        id="visual-field"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`3.2 ${t("Visual Field")}`} />
        <Box sx={{ mx: "20px" }}>
          <VisualField />
        </Box>
      </Box>

      <Box
        id="visual-acuity"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`3.3 ${t("Visual Acuity")}`} />
        <Box sx={{ mx: "20px" }}>
          <VisualAcuity />
        </Box>
      </Box>

      <Box
        id="contrast-sensitivity"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`3.4 ${t("Contrast Sensitivity")}`} />
        <Box sx={{ mx: "20px" }}>
          <ContrastSensitivity />
        </Box>
      </Box>

      <Box
        id="color-vision"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`3.5 ${t("Color Vision")}`} />
        <Box sx={{ mx: "20px" }}>
          <ColorVision />
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default Features;
